<ion-item lines="none">
	<ion-text class="empty">
		{{ message }}
	</ion-text>
</ion-item>
